import { useApi, useAuth } from '../../hooks';
import { useQuery } from '@tanstack/react-query';
import { UserDiagnosis } from '../types';

export const useUserDiagnosis = (userId?: string) => {
  const { api } = useApi();
  const { isAuthenticated, loading, userToken } = useAuth();

  const fetchUserDiagnosis = async () => {
    const requestObj = {
      route: `/private/user-diagnosis/?user_id=${userId}`,
      token: userToken,
    };

    return await api(requestObj);
  };

  const { data, isLoading, isError } = useQuery<UserDiagnosis[], Error>({
    queryKey: ['hc-user-diagnosis', userToken, userId],
    queryFn: () => fetchUserDiagnosis(),
    enabled: !!userId && isAuthenticated && !loading && !!userToken,
    refetchOnWindowFocus: false,
  });

  return { data, isLoading, isError };
};
